import { Table as TableIcon } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { OpenOrdersPage } from './pages/OpenOrdersPage'

/**
 * Open Orders — M6. First real module end-to-end (spec §8).
 *
 * Replaces reports.siliconesplus.com/orders at M11 cutover. Data parity
 * via `POST /api/open-orders/detailed`; sidebar badge via
 * `GET /api/open-orders/count` (M6 adds this endpoint).
 */
export default defineModule({
  id: 'open-orders',
  name: 'Open Orders',
  shortName: 'Orders',
  icon: TableIcon,
  navSection: 'sales',
  navOrder: 10,
  urlNamespace: '/orders',
  routes: [{ path: '/', element: OpenOrdersPage, label: 'Open Orders' }],
  permissions: [
    'admin', 'sales', 'outside_sales_rep', 'inside_sales_rep',
    'operations', 'operations_logistics', 'purchasing', 'finance',
  ],
  densityDefault: 'comfortable',
  filterRailDefault: 'collapsed',
  mobileStrategy: 'responsive',

  keyboardShortcut: 'g o',

  commandPaletteEntries: [
    {
      label: 'Go to Open Orders',
      keywords: ['orders', 'customer', 'so', 'sale', 'late'],
      path: '/',
      group: 'modules',
      shortcut: 'g o',
    },
  ],

  // The customer entity can be linked back into Open Orders via this
  // handler (e.g. from a Customer Pricelist detail drawer). Sales Quoting
  // / Pricelists modules will register their own handlers in Phase 2.
  deepLinkHandlers: [
    {
      entity: 'customer',
      label: 'View customer\'s open orders',
      buildPath: (customerId) => `/?customer=${customerId}`,
    },
  ],

  consumesServices: ['odoo-search'],
})
